<div class="ngn-multiselect" ngnClickOutside (clickOutside)="closeDropdown()">
  <div class="selected-list" #selectedList>
    <div class="c-btn" (click)="toggleDropdown($event)" [ngClass]="{'disabled': settings.disabled}">
      <ng-container *ngIf="!settings.iconMode">
        <span class="c-btn-label"
              *ngIf="(selectedItems?.length == 0 && settings.showBadge == true) || (!settings.showBadge && appliedItems?.length == 0)">{{settings.text}}</span>
        <span class="c-btn-label" *ngIf="appliedItems?.length > 0 && !settings.showBadge">
          <span class="c-selected-count">{{appliedItems.length}}</span> {{settings.textSelected}}
        </span>
        <ng-container *ngIf="settings.singleSelection">
          <span *ngFor="let item of selectedItems;trackBy: trackByFn.bind(this);">
            {{item[settings.labelKey]}}
          </span>
        </ng-container>
        <ng-container *ngIf="settings.showBadge">
          <div class="c-list" *ngIf="selectedItems?.length > 0 && !settings.singleSelection">
            <div class="c-token" *ngFor="let item of selectedItems;trackBy: trackByFn.bind(this);let k = index"
                 [hidden]="k > settings.badgeShowLimit-1">
              <span *ngIf="!badgeTempl" class="c-label">{{item[settings.labelKey]}}</span>
              <span *ngIf="badgeTempl" class="c-label">
                <ngn-c-template-renderer [data]="badgeTempl" [item]="item"></ngn-c-template-renderer>
              </span>
              <span class="c-remove" (click)="onItemClick(item,k,$event)">
                <svg width="100%" height="100%" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 47.971 47.971" style="enable-background:new 0 0 47.971 47.971;" xml:space="preserve">
                  <g>
                    <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
      c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
      C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
      s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z" />
                  </g>
                </svg>
              </span>
            </div>
          </div>
          <span class="countplaceholder" *ngIf="selectedItems?.length > settings.badgeShowLimit">+{{selectedItems?.length - settings.badgeShowLimit }}</span>
        </ng-container>
        <span *ngIf="!isActive" class="c-angle-down">
          <i class="ngn-icon ngn-icon-arrow-down"></i>
        </span>
        <span *ngIf="isActive" class="c-angle-up">
          <i class="ngn-icon ngn-icon-arrow-up"></i>
        </span>
      </ng-container>
      <ng-container *ngIf="settings.iconMode">
        <ngn-c-template-renderer *ngIf="iconTempl" [data]="iconTempl" [item]="item"></ngn-c-template-renderer>
        <i *ngIf="!iconTempl" class="ngn-icon ngn-icon-filter"></i>
      </ng-container>
    </div>
  </div>
  <div [ngnSetPosition]="selectedListHeight?.val" class="dropdown-list"
       [ngClass]="{'dropdown-list-top': settings.position == 'top', 'dropdown-align-left': settings.align == 'left'}"
       [hidden]="!isActive">
    <div [ngClass]="{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}"
         class="arrow-2"></div>
    <div [ngClass]="{'arrow-up': settings.position == 'bottom', 'arrow-down': settings.position == 'top'}"></div>
    <div class="list-area">

      <div class="list-filter" *ngIf="settings.enableSearchFilter">
        <span class="c-search">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="100%" height="100%" viewBox="0 0 615.52 615.52" style="enable-background:new 0 0 615.52 615.52;" xml:space="preserve">
            <g>
              <g>
                <g id="Search__x28_and_thou_shall_find_x29_">
                  <g>
                    <path d="M602.531,549.736l-184.31-185.368c26.679-37.72,42.528-83.729,42.528-133.548C460.75,103.35,357.997,0,231.258,0
					C104.518,0,1.765,103.35,1.765,230.82c0,127.47,102.753,230.82,229.493,230.82c49.53,0,95.271-15.944,132.78-42.777
					l184.31,185.366c7.482,7.521,17.292,11.291,27.102,11.291c9.812,0,19.62-3.77,27.083-11.291
					C617.496,589.188,617.496,564.777,602.531,549.736z M355.9,319.763l-15.042,21.273L319.7,356.174
					c-26.083,18.658-56.667,28.526-88.442,28.526c-84.365,0-152.995-69.035-152.995-153.88c0-84.846,68.63-153.88,152.995-153.88
					s152.996,69.034,152.996,153.88C384.271,262.769,374.462,293.526,355.9,319.763z" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </span>
        <input class="c-input" *ngIf="!settings.lazyLoading && !searchTempl" #searchInput type="text"
               [placeholder]="settings.searchPlaceholderText"
               [(ngModel)]="filter">
        <input class="c-input" *ngIf="settings.lazyLoading && !searchTempl" #searchInput type="text"
               [placeholder]="settings.searchPlaceholderText"
               (keyup)="filterInfiniteList($event)">
        <ngn-c-template-renderer *ngIf="searchTempl" [data]="searchTempl" [item]="item"></ngn-c-template-renderer>
      </div>
      <ul *ngIf="!settings.groupBy" [style.maxHeight]="settings.maxHeight+'px'" class="lazyContainer">
        <div class="custom-control custom-checkbox select-all"
             *ngIf="settings.enableCheckAll && !settings.singleSelection && !settings.limitSelection"
             (click)="toggleSelectAll()">
          <input *ngIf="settings.showCheckbox" class="custom-control-input" type="checkbox" [checked]="isSelectAll"
                 [disabled]="settings.limitSelection == selectedItems?.length"
          />
          <label class="custom-control-label">
            <span [hidden]="isSelectAll">{{settings.selectAllText}}</span>
            <span [hidden]="!isSelectAll">{{settings.unSelectAllText}}</span>
          </label>
        </div>
        <ng-container *ngIf="itemTempl">
          <li *ngFor="let item of data | listFilter: filter : settings.searchBy; let i = index;"
              (click)="onItemClick(item,i,$event)"
              class="custom-control custom-checkbox">
            <input *ngIf="settings.showCheckbox" class="custom-control-input" type="checkbox"
                   [checked]="isSelected(item)"
                   [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"
            />
            <label class="custom-control-label"></label>
            <ngn-c-template-renderer [data]="itemTempl" [item]="item"></ngn-c-template-renderer>
          </li>
        </ng-container>
        <ng-container *ngIf="!itemTempl && !settings.lazyLoading">
          <li *ngFor="let item of data | listFilter:filter : settings.searchBy; let i = index;"
              (click)="onItemClick(item,i,$event)"
              class="custom-control custom-checkbox">
            <input *ngIf="settings.showCheckbox" class="custom-control-input" type="checkbox"
                   [checked]="isSelected(item)"
                   [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"
            />
            <label class="custom-control-label">{{item[settings.labelKey]}}</label>
          </li>
        </ng-container>
        <ng-container *ngIf="!itemTempl && settings.lazyLoading">
          <div [ngStyle]="{'height':totalHeight+'px'}" style="position: relative;">
            <li *ngFor="let item of chunkArray | listFilter:filter : settings.searchBy; let i = index;"
                (click)="onItemClick(item,i,$event)"
                style="position: absolute;width: 100%;" class="custom-control custom-checkbox" ngnStyleProp
                [styleVal]="chunkIndex[i]">
              <input *ngIf="settings.showCheckbox" class="custom-control-input" type="checkbox"
                     [checked]="isSelected(item)"
                     [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"
              />
              <label class="custom-control-label">{{item[settings.labelKey]}}</label>
            </li>
          </div>
        </ng-container>
      </ul>
      <div *ngIf="settings.groupBy" [style.maxHeight]="settings.maxHeight+'px'" style="overflow: auto;">
        <ul *ngFor="let obj of groupedData ; let i = index;" class="list-grp">
          <h4 *ngIf="(obj.value | listFilter:filter : settings.searchBy ).length > 0">{{obj.key}}</h4>
          <ng-container *ngIf="itemTempl">
            <li *ngFor="let item of obj.value | listFilter:filter : settings.searchBy; let i = index;"
                (click)="onItemClick(item,i,$event)"
                class="custom-control custom-checkbox">
              <input *ngIf="settings.showCheckbox" class="custom-control-input" type="checkbox"
                     [checked]="isSelected(item)"
                     [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"
              />
              <label class="custom-control-label"></label>
              <ngn-c-template-renderer [data]="itemTempl" [item]="item"></ngn-c-template-renderer>
            </li>
          </ng-container>
          <ng-container *ngIf="!itemTempl">
            <li *ngFor="let item of obj.value | listFilter:filter : settings.searchBy; let i = index;"
                (click)="onItemClick(item,i,$event)"
                class="custom-control custom-checkbox">
              <input *ngIf="settings.showCheckbox" class="custom-control-input" type="checkbox"
                     [checked]="isSelected(item)"
                     [disabled]="settings.limitSelection == selectedItems?.length && !isSelected(item)"
              />
              <label class="custom-control-label">{{item[settings.labelKey]}}</label>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="list-buttons" *ngIf="(settings.showApply || settings.showClear) && !settings.singleSelection">
        <button *ngIf="settings.showClear" class="btn btn-outline-secondary clear-btn mr-1 float-left"
                (click)="onClearClick()">Clear
        </button>
        <button *ngIf="settings.showApply" class="btn btn-primary apply-btn ml-1 float-right"
                [disabled]="selectedItems?.length <=0" (click)="onApplyClick()">Apply
        </button>
      </div>
      <div class="list-message" *ngIf="data?.length == 0">{{settings.noDataLabel}}</div>
    </div>
  </div>
</div>
